// Lodash
import { get } from 'lodash';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { ClientState, initialState } from './state';


/**
 * This effect is for listen Client actions, execute auth service call and dispatch in Client reducer.
 * For Client api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 01-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created Client effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): ClientState {
  switch (action.type) {
    // Client COMMON METHOD
    case ActionTypes.CLIENT_COMMON: {
      return state;
    }
    // Client Success COMMON METHOD
    case ActionTypes.CLIENT_COMMON_SUCCESS: {
      // commonly store and handle all Client modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // GET_LOCATION_BY_CLIENT
    case ActionTypes.GET_LOCATION_BY_CLIENT_SUCCESS: {

      return {
        ...state,
        locationLookup: {
          ...state.locationLookup,
          [action.response.action.client_id]:   action.response && action.response.data && action.response.data.data ?  action.response.data.data.location : [],
        },
      };
    }

    // GET_STATE_BY_COUNTRY
    case ActionTypes.CLIENT_BY_ID_SUCCESS: {
      return {
        ...state,
        clientById: {
          ...state.clientById,
          [action.response.data.data.clients[0].client_id]: action.response.data.data.clients[0],
        },
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }

    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
